import { ArrowRight, FileDown, ShieldCheck } from "lucide-react";
import { API } from "../../lib/api";
import { useQuote } from "../../context/QuoteContext";

export function ProductCard({ product: p, index = 0 }) {
  const { openQuote, openSpecs } = useQuote();
  const specs = Object.entries(p.specs).slice(0, 3);
  return (
    <article className="pcard" style={{ animationDelay: `${(index % 6) * 60}ms` }} data-testid={`product-card-${p.slug}`}>
      <div className="pcard-media" onClick={() => openSpecs(p)}>
        <img src={p.image} alt={p.name} loading="lazy" />
        <span className="pcard-cat">{p.category}</span>
        {p.gem_listed && <span className="glass-chip"><ShieldCheck size={12} /> GeM listed</span>}
      </div>
      <div className="pcard-body">
        <small>{p.tagline}</small>
        <h3>{p.name}</h3>
        <dl>{specs.map(([k, v]) => <div key={k}><dt>{k}</dt><dd>{v}</dd></div>)}</dl>
        <div className="pcard-actions">
          <button className="button button-orange sm" onClick={() => openQuote({ product: p, source: "product-card" })} data-testid={`product-bulk-quote-${p.slug}`}>Request bulk quote <ArrowRight size={14} /></button>
          <button className="button button-ghost sm" onClick={() => openSpecs(p)} data-testid={`product-specs-${p.slug}`}>Specs</button>
          <a className="icon-square" href={`${API}/products/${p.slug}/spec-sheet.pdf`} title="Download PDF spec sheet" data-testid={`product-pdf-${p.slug}`}><FileDown size={16} /></a>
        </div>
      </div>
    </article>
  );
}
